import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=079f967b&"
import script from "./AddItem.vue?vue&type=script&lang=ts&"
export * from "./AddItem.vue?vue&type=script&lang=ts&"
import style0 from "./AddItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VInput,VRow})
